export default {
  '<3': 'OPEN',
  '</3': 'CLOSE',
  'can.i.just.say.something:': 'OUT',
  'newsfeed:': 'IN',
  'i.cant.even:': 'ERROR',
  'um': 'IF',
  'duh': 'ENDIF',
  'so': 'WHILE',
  'totes': 'ENDWHILE',
  'short': 'TYPE',
  'tall': 'TYPE',
  'grande': 'TYPE',
  'uggs': 'TYPE',
  'retweet': 'TYPE',
  'trenta': 'TYPE',
  'venti': 'TYPE',
  'can.you.not(': 'MATH',
  ':': 'MATH',
  '/': 'MATH',
  '*': 'MATH',
  '(': 'MATH',
  ')': 'MATH',
  '-': 'MATH',
  '+': 'MATH',
  '=': 'MATH',
  '"': 'QUOTE',
  "'": 'QUOTE',
  '#': 'REFID',
} as any;
